import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';

export default [
  {
    label: 'Událost',
    field: 'entity',
    type: ColumnType.TEXT,
    width: 300
  },
  {
    label: 'Uživatel',
    field: 'user',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Vytvořeno',
    field: 'created',
    type: ColumnType.DATETIME,
    width: 100,
    compact: true
  }
];



// WEBPACK FOOTER //
// ./src/modules/history/_historyColumns.ts